import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "menu",
  "use": "menu-usage",
  "viewBox": "0 0 500 501",
  "content": "<symbol viewBox=\"0 0 500 501\" xmlns=\"http://www.w3.org/2000/svg\" id=\"menu\"><title>icon-menu</title><path d=\"M51 92.958v32.44h400v-32.44H51zm0 140.576v32.441h400v-32.44H51zm0 140.577v32.44h400v-32.44H51z\" fill=\"currentColor\" fill-rule=\"nonzero\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol